import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientsComponent } from './clients.component';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';
import { ClientsRoutingModule } from './clients-routing.module';
import { AppMaterialModule } from 'src/app/app-material.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxCurrencyModule, CurrencyMaskInputMode } from 'ngx-currency';

import { TableComponent } from './components/table/table-clients.component';
import { ClientConfigComponent } from './modals/client-config/client-config.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientDetailsComponent } from './modals/client-details/client-details.component';
import { CustomPipeModule } from 'src/app/shared/pipes/custom-pipes.module';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { PartnerDocumentComponent } from './components/partner-document/partner-document.component';
import { TableLogComponent } from './components/table-log/table-log.component';

export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
  nullable: true,
  min: null,
  max: null,
  inputMode: CurrencyMaskInputMode.FINANCIAL,
};

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    ReactiveFormsModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    FormsModule,
    ClientsRoutingModule,
    CustomPipeModule,
    AppMaterialModule,
    NgxMaskModule.forChild(),
    DirectivesModule,
  ],
  declarations: [
    ClientsComponent,
    TableComponent,
    TableLogComponent,
    ClientConfigComponent,
    ClientDetailsComponent,
    PartnerDocumentComponent,
  ],
})
export class ClientsModule {}
